import { generate_guid } from '@/rlMxModules/utils/util'

class rlWallHoleSectData {
  constructor(B = null, H = null, Guid = null) {
    this.B = B //墙洞宽度
    this.H = H;//墙洞宽度
    this.Guid = Guid ? Guid : generate_guid()
  }
}

export default rlWallHoleSectData
